import React from 'react';
import '../styles/header.css';

export const Header = () => {
    return (
        <header className="header">
            <h1>Portfolio de Pablo Alejandro de la Iglesia</h1>
        </header>
    );
};

// export default Header;
